import {
  DOCTOR_SEARCH, DOCTOR_SEARCH_SUCCESS, DOCTOR_SEARCH_FAILURE, DOCTOR_CLEAR,
  DOCTOR_SEARCH_AUTOCOMPLETE_SUCCESS, DOCTOR_AUTOCOMPLETE_CLEAR,
  DOCTOR_SEARCH_DETAIL, DOCTOR_SEARCH_DETAIL_FAILURE, DOCTOR_SEARCH_DETAIL_SUCCESS, DOCTOR_DETAIL_CLEAR,
  DOCTOR_EDIT, DOCTOR_EDIT_FAILURE, DOCTOR_EDIT_SUCCESS, DOCTOR_EDIT_CLEAR,
  DOCTOR_SEARCH_HISTORY, DOCTOR_SEARCH_HISTORY_FAILURE, DOCTOR_SEARCH_HISTORY_SUCCESS,
  DOCTOR_DELETE, DOCTOR_DELETE_FAILURE, DOCTOR_DELETE_SUCCESS,
  DOCTOR_DUPLICATE_CHECK, DOCTOR_DUPLICATE_CHECK_SUCCESS, DOCTOR_DUPLICATE_CHECK_FAILURE,
  DOCTOR_MSG_ALERT, DOCTOR_SEARCH_DOCTOR_CODE, DOCTOR_SEARCH_DOCTOR_CODE_SUCCESS, DOCTOR_SEARCH_DOCTOR_CODE_FAILURE, CLEAR_DOCTOR_CODE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    doctor: null,
    doctors: [],
    doctorHistories: null,
    doctorsAutocomplete: null,
    doctorsNextPage: 1,
    doctorsTotalCount: 0,
    doctorsNextPageLink: null,
    doctorsCurrentPage: null,
    searchParams: null,
    doctorNotify: null,
    doctorCodeList: []
  },
  getters: {
    doctor: state => {
      return state.doctor
    },
    doctors: state => {
      return state.doctors
    },
    doctorHistories: state => {
      return state.doctorHistories
    },
    doctorsAutocomplete: state => {
      return state.doctorsAutocomplete
    },
    doctorsNextPage: state => {
      return state.doctorsNextPage
    },
    doctorsTotalCount: state => {
      return state.doctorsTotalCount
    },
    doctorsNextPageLink: state => {
      return state.doctorsNextPageLink
    },
    doctorsCurrentPage: state => {
      return state.doctorsCurrentPage
    },
    doctorsSearchParams: state => {
      return state.searchParams
    },
    /** 通知 */
    doctorNotify: state => {
      return state.doctorNotify
    },
    doctorCodeList: state => {
      return state.doctorCodeList
    }
  },
  actions: {
    [DOCTOR_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/doctors'
      var loadparams = true
      var noneList = null
      var callback = () => {}
      if (params) {
        data = params.data
        state.searchParams = params.data
        if (params.autocomplete) {
          loadparams = false
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('noneList' in params) {
          noneList = params.noneList
        }
        if ('callback' in params) {
          callback = params.callback
        }
        if (params.url) {
          url = params.url
        }
        if (params.clear) {
          state.doctors = null
          state.doctorsNextPage = 0
          state.doctorsTotalCount = 0
          state.doctorsNextPageLink = null
          state.doctorsCurrentPage = null
        }
      }

      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOCTOR_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            if (params.autocomplete) {
              commit(DOCTOR_SEARCH_AUTOCOMPLETE_SUCCESS, {data: res.data, noneList: noneList, callback: callback})
            } else {
              commit(DOCTOR_SEARCH_SUCCESS, {data: res.data, callback: callback})
            }
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DOCTOR_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(DOCTOR_CLEAR)
      }, sleep)
    },
    [DOCTOR_DETAIL_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(DOCTOR_DETAIL_CLEAR)
      }, sleep)
    },
    [DOCTOR_EDIT_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(DOCTOR_EDIT_CLEAR)
      }, sleep)
    },
    [DOCTOR_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(DOCTOR_AUTOCOMPLETE_CLEAR)
      }, sleep)
    },
    [DOCTOR_SEARCH_DETAIL]  ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiGet', {url: '/doctors/' + params.doctorId, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOCTOR_SEARCH_DETAIL_FAILURE, res.data)
          } else {
            commit(DOCTOR_SEARCH_DETAIL_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DOCTOR_SEARCH_HISTORY] ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiGet', { url: '/doctors/hist', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOCTOR_SEARCH_HISTORY_FAILURE, res.data)
          } else {
            commit(DOCTOR_SEARCH_HISTORY_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DOCTOR_EDIT]  ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiPost', {url: '/doctors', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOCTOR_EDIT_FAILURE, res.data)
          } else {
            commit(DOCTOR_EDIT_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DOCTOR_DELETE]  ({dispatch, state, commit}, params) {
      var callback = params.callback
      dispatch('apiDelete', {url: '/doctors/' + params.historyId})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOCTOR_DELETE_FAILURE, res.data)
          } else {
            commit(DOCTOR_DELETE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DOCTOR_DUPLICATE_CHECK] ({dispatch, state, commit}, params) {
      var data = params.data
      var callback = params.callback
      dispatch('apiGet', {url: '/doctors/duplicate_check', data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOCTOR_DUPLICATE_CHECK_FAILURE, res.data)
          } else {
            commit(DOCTOR_DUPLICATE_CHECK_SUCCESS, { data: res.data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DOCTOR_MSG_ALERT] ({state, commit}, msg) {
      commit(DOCTOR_MSG_ALERT, msg)
    },
    [DOCTOR_SEARCH_DOCTOR_CODE] ({dispatch, state, commit}, params) {
      var data = params.data
      dispatch('apiGet', {url: '/doctors/search_doctor_code', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOCTOR_SEARCH_DOCTOR_CODE_FAILURE, res.data)
          } else {
            commit(DOCTOR_SEARCH_DOCTOR_CODE_SUCCESS, { data: res.data })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLEAR_DOCTOR_CODE] ({state}) {
      state.doctorCodeList = []
    }
  },
  mutations: {
    [DOCTOR_SEARCH_FAILURE] (state, data) {
      console.log('DOCTOR_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [DOCTOR_SEARCH_SUCCESS] (state, params) {
      console.log('DOCTOR_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      state.doctorsTotalCount = 0

      if (reSearch) {
        // 再検索
        state.doctors = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.doctorsNextPage = null
        }
      } else {
        if (data.meta) {
          if (data.meta['current-page'] && data.meta['current-page'] > 1) {
            state.doctors = state.doctors.concat(data.data)
            state.doctorsCurrentPage = data.meta['current-page']
          } else {
            state.doctors = data.data
            state.doctorsCurrentPage = data.meta['current-page']
          }
          state.doctorsNextPage = null
          if (data.meta['next-page']) {
            state.doctorsNextPage = data.meta['next-page']
          }
        } else {
          state.doctors = data.data
        }
        state.doctorsNextPageLink = null
        if (data.links && data.links['next']) {
          state.doctorsNextPageLink = data.links['next']
        } else {
          state.doctorsNextPageLink = null
        }
      }

      if (data.meta && data.meta['total-count']) {
        state.doctorsTotalCount = data.meta['total-count']
      }

      if (params.callback) {
        params.callback()
      }
    },
    [DOCTOR_CLEAR] (state) {
      state.doctors = []
    },
    [DOCTOR_DETAIL_CLEAR] (state) {
      state.doctorHistories = null
    },
    [DOCTOR_EDIT_CLEAR] (state) {
      state.doctor = null
    },
    [DOCTOR_SEARCH_AUTOCOMPLETE_SUCCESS] (state, param) {
      console.log('DOCTOR_SEARCH_AUTOCOMPLETE_SUCCESS')
      var data = param.data.data
      state.doctorsAutocomplete = data
      // なし追加
      if (param.noneList !== null) {
        if (state.doctorsAutocomplete === null) {
          state.doctorsAutocomplete = []
        }
        state.doctorsAutocomplete.unshift({
          'id': param.noneList['id'],
          'type': 'doctors',
          'attributes': {
            'doctor-name': param.noneList['name'],
            'doctor-name-furigana': '',
            'email': ''
          }
        })
      }
    },
    [DOCTOR_AUTOCOMPLETE_CLEAR] (state) {
      console.log('DOCTOR_AUTOCOMPLETE_CLEAR')
      state.doctorsAutocomplete = null
    },
    [DOCTOR_SEARCH_DETAIL_FAILURE] (state, data) {
      console.log('DOCTOR_SEARCH_DETAIL_FAILURE')
    },
    [DOCTOR_SEARCH_DETAIL_SUCCESS] (state, params) {
      console.log('DOCTOR_SEARCH_DETAIL_SUCCESS')
      state.doctorHistories = params.data.data
      if (params.callback) {
        params.callback(params.data.data)
      }
    },
    [DOCTOR_SEARCH_HISTORY_FAILURE] (state, data) {
      console.log('DOCTOR_SEARCH_HISTORY_FAILURE')
    },
    [DOCTOR_SEARCH_HISTORY_SUCCESS] (state, params) {
      console.log('DOCTOR_SEARCH_HISTORY_SUCCESS')
      state.doctor = params.data.data
      if (params.callback) {
        params.callback()
      }
    },
    [DOCTOR_EDIT_FAILURE] (state, data) {
      console.log('DOCTOR_EDIT_FAILURE')
      // 通知
      state.doctorNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.doctorNotify = null
      }, constant.notifyShowTime.normal)
    },
    [DOCTOR_EDIT_SUCCESS] (state, params) {
      console.log('DOCTOR_EDIT_SUCCESS')
      state.doctor = params.data.data
      if (params.callback) {
        params.callback()
      }
      // 通知
      state.doctorNotify = {
        success: true,
        message_i18n: 'messages.save.success'
      }
      setTimeout(() => {
        state.doctorNotify = null
      }, constant.notifyShowTime.normal)
    },
    [DOCTOR_DELETE_FAILURE] (state, data) {
      console.log('DOCTOR_DELETE_FAILURE')
      // 通知
      state.doctorNotify = {
        danger: true,
        message_i18n: 'messages.delete.danger'
      }
      setTimeout(() => {
        state.doctorNotify = null
      }, constant.notifyShowTime.normal)
    },
    [DOCTOR_DELETE_SUCCESS] (state, params) {
      console.log('DOCTOR_DELETE_SUCCESS')
      if (params.callback) {
        params.callback()
      }
      // 通知
      state.doctorNotify = {
        success: true,
        message_i18n: 'messages.delete.success'
      }
      setTimeout(() => {
        state.doctorNotify = null
      }, constant.notifyShowTime.normal)
    },
    [DOCTOR_DUPLICATE_CHECK_FAILURE] (state, data) {
      console.log('DOCTOR_DUPLICATE_CHECK_FAILURE')
    },
    [DOCTOR_DUPLICATE_CHECK_SUCCESS] (state, data) {
      console.log('DOCTOR_DUPLICATE_CHECK_SUCCESS')
      if (data.callback !== null) {
        data.callback(data.data)
      }
    },
    [DOCTOR_MSG_ALERT] (state, msg) {
      state.doctorNotify = msg
      setTimeout(() => { state.doctorNotify = null }, constant.notifyShowTime.normal)
    },
    [DOCTOR_SEARCH_DOCTOR_CODE_FAILURE] (state, data) {
      console.log('DOCTOR_SERARCH_DOCTOR_CODE_FAILURE')
    },
    [DOCTOR_SEARCH_DOCTOR_CODE_SUCCESS] (state, data) {
      console.log('DOCTOR_SEARCH_DOCTOR_CODE_SUCCESS')
      state.doctorCodeList = data.data.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/doctor.js